import { plans } from './fakePlan';

export const getPlan = async () => {
  return plans;
};
